import { Component, input } from '@angular/core';

@Component({
  selector: 'app-content-card',
  standalone: true,
  templateUrl: './content-card.component.html',
  styleUrl: './content-card.component.scss',
})
export class ContentCardComponent {
  /** Optional left-aligned title above the projected content. */
  readonly title = input<string | null>(null);
}
